import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Patient } from '../patients/patient';
import { PatientsService } from '../patients.service';
import { ExamsService } from '../exams.service';
import { LoginService } from '../login.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommerrorService } from '../commerror.service';
import { PregnancyService } from '../pregnancy.service';
import { GastroFormsService } from '../gastro-forms.service';
import { DiagnosisService } from '../diagnosis.service';
import { CalendarService } from '../calendar.service';
import { SignatureService } from '../signature.service';
import { Exam } from '../interfaces/exams.service/types';
import { PathologyService } from '../pathology.service';
import { MatDialog } from '@angular/material/dialog';
import { PrescriptionDialogComponent } from '../prescription/prescription-dialog.component';
import { PrescriptionService, Prescription } from '../prescription.service';
import { BloodTestReferralService } from '../blood-test-referral.service';
import { HttpClient } from '@angular/common/http';
import { CONSENT_TYPES, resolveConsentTypeKey } from '../consent-types';

// Today List codes of the endoscopy sub-types -> exam SubExamType
const ENDOSCOPY_CODE_TO_SUBTYPE: Record<string, string> = {
  'HRA': 'HRA'
};

@Component({
    selector: 'app-patexams',
    templateUrl: './patexams.component.html',
    styleUrls: ['./patexams.component.scss'],
    standalone: false
})
export class PatexamsComponent implements OnInit, OnDestroy {
  @ViewChild('inputTitle')
  set inputTitle(element: ElementRef<HTMLInputElement>) {
    if (element) {
      element.nativeElement.focus()
    }
  }
  inform = false;
  showComment = false;
  selectedForm;
  calendarForm: boolean = false;
  pat: Patient;
  showPat: boolean = false;
  pregnancies: any = null;
  etype: string = "OB STD";
  typeForm = false;
  examname: string;
  concentForm;
  otherExams: any;
  formsExams: any[] = [];
  clinicsExams: any[] = [];
  calendarForms: any[] = []
  notFormExams: any[] = [];
  ecgExams: any[] = [];
  gastroForms: any[] = [];
  usGeneralExams: any[] = [];
  patInbox: any[] = [];
  letters: any;
  showLogin = false;
  AWLAlreadyExists = false;
  private destroy$ = new Subject();
  public examsLoaded$ = new Subject<void>();
  toDelete;
  readydelete = false;
  documentDelete = false;
  AttachedDocuments: any[] = [];
  goEx;
  newExam = true;
  closePreg: number = null;
  pregExams;
  defaults;
  startClinic: number;
  openAWL = false;
  subscription = new Subscription()
  FORMS = ['Consultation Letter', 'consultation and follow up with media', 'Inform Consent'];
  CLINICS = ['Clinics'];
  ECG = ['Resting ECG', 'Ergometry', 'Holter ECG'];
  CARDIO = ['TTE Adults','Duplex Carotid', 'Stress', 'Stress-Echo'];
  usGenral = [ 'Abdomen US', 'MSK Musculoskeletal', 'MSK & Soft Tissues', 'Neck scan', 'Ultrasound Scan Summary', 'Endoscopy'];
  INVASIVE = ['Amniocentesis', 'CVS'];
  endoscopySubType: string = '';
  formMissing=false
  mustHaveFormAdmission=['Colonoscopy', 'Gastroscopy', 'Sigmoidoscopy']
  showPrintPopup=false
  examIdSelectedPrintForm=null

  GastroForms = ['Admission Form', 'Time Out Form','Recovery Form','Release Form'];
  usGeneralExamsChanged = new Subject()
  fanciness = 'simple';
  save: boolean = false;
  labReportID: number = null;
  prescriptions: Prescription[] = [];
  prescriptionToDelete: Prescription = null;
  prescriptionDeleteReady = false;
  referralToDelete: any = null;
  referralDeleteReady = false;
  openDocumentsAdd = false;

  private examUnSignedSub: Subscription;
  clinicPractitioners: any[] = [];
  myClinicTemplates: any[] = [];
  selectedClinicTemplateId: any = null;
  showUsgConsent: boolean = false;
  usgConsents: any[] = [];
  consentTypes = CONSENT_TYPES;
  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  patientQuestionnaires: any[] = [];
  currentSignatureUrl: any = null;
  signatureLoading = false;
  signatureUploadStatus = '';
  practitionerSignatures: { [uid: string]: { url: any; loading: boolean; status: string } } = {};

  constructor(
    public ce: CommerrorService,
    public gfs: GastroFormsService,
    public patService: PatientsService,
    public ps: PregnancyService,
    public examService: ExamsService,
    public login: LoginService,
    public ds: DiagnosisService,
    public cf: CalendarService,
    public signatureService: SignatureService,
    private pathologyService: PathologyService,
    private dialog: MatDialog,
    private prescriptionService: PrescriptionService,
    private referralService: BloodTestReferralService,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  redirectAdministration(type) {
    this.http.post('/api/administration', { type }).subscribe((data: string) => {
      window.location.href = data + '/' + this.pat.PID;
    });
  }

  ngOnInit() {
    this.login.loginMissing();
    if (!this.login.ishospital && this.login.premissions?.Consent) {
      this.examService.getAllPractitioners().subscribe((data: any) => {
        this.clinicPractitioners = data;
        const selectedPractitioner = this.resolveConsentPractitioner();
        if (selectedPractitioner) {
          this.examService.consentPractitioner = selectedPractitioner.Title + ' ' + selectedPractitioner.Name;
        }
        this.setConsentDocUID();
        if (this.pat?.ID === 'default' && this.login.userType === 'secretary') {
          this.loadAllPractitionerSignatures();
        }
      });
    }
    try {
      this.pat = this.patService.getPat();
      //this.pat.asignVals(history.state.data);
    }
    catch { }
    
    try {
      this.examService.getMyClinicTemplates().subscribe(
        (data: any) => { this.myClinicTemplates = data || []; },
        (err) => { console.log(err); }
      );
    } catch (e) { console.log(e); }

    if (this.login.isUSG)
      this.etype = "Ultrasound";
    if(this.login.userType=='nurse'){
      this.etype='GastroForms'
    }
    if(this.login.category.name == 'forms')
      this.etype = 'Forms'
    if (this.pat.ID != "default") {
      this.resetPregs();
    }
    else {//defaults
      if (this.login.userType === 'doctor' && this.login.premissions?.Consent) {
        this.loadCurrentSignature();
      }
      this.examService.getDefaults().subscribe((data) => {
        this.defaults = [];
        for (let i = 0; i < data["length"]; i++)
          this.defaults[data[i]["ExamType"]] = data[i];
      },
        (error) => {
          console.error(error);
        });
    }
    this.subscription = this.patService.lettersChange.subscribe(
      (response) => {
        this.letters = response;
      }
    )
    this.subscription =this.cf.caldeleted$.subscribe((data) => {
        this.resetPregs();
    })
    this.getLabInbox();
  }

  resetPregs(){
    this.usgConsents = [];
    this.loadPatientQuestionnaires();
    if (this.login.premissions?.Consent) {
      this.examService.getUsgConsents(this.pat.PID.toString()).pipe(takeUntil(this.destroy$)).subscribe(
        (data) => { this.usgConsents = data || []; },
        () => {}
      );
    }
    this.examService.getExams(this.pat.PID.toString()).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.pregnancies = data["pregnancies"];
      this.examService.pregnancies = data["pregnancies"];
      this.AttachedDocuments = data["Documents"] || [];
      // Load prescriptions for this patient
      if (this.login.premissions?.Prescriptions) {
        this.prescriptionService.getAll(this.pat.PID.toString(), this.login.GID).subscribe(
          (data) => { this.prescriptions = data; },
          () => { this.prescriptions = []; }
        );
      }
      for(let item of this.pregnancies){
        this.examService.getAllCalForms(item.AutoIndex).pipe(takeUntil(this.destroy$)).subscribe((data) => {
          if(data[0].calendar.length > 0)
            item.calendarForms.push(data[0].calendar[0])
          if(data[0].concent.length > 0)
            item.forms = data[0].concent
            // for(let concentForm of data[0].concent)
            // item.forms.push(concentForm)

        });
        // this.examServe.getConcentForms(item.AutoIndex).subscribe((data) => {
        //   if(data[0])
        //     item.forms.push(data[0])
        // })
      }
      
      if (this.pregnancies && this.pregnancies.length > 0 && this.pregnancies[0].LMP)
        this.pat.LMP = this.pregnancies[0].LMP
      // this.letters = this.patService.getConsultationLetter(this.pat);
      this.otherExams = data["other"];
      if (this.otherExams.length > 0) {
        this.otherExams.forEach((exam) => {
          if (this.CLINICS.includes(exam.ExamType)) {
            this.clinicsExams.push(exam)
          } else if (this.FORMS.includes(exam.ExamType)) {
            this.formsExams.push(exam)
          } else {
            if (this.ECG.includes(exam.ExamType))
              this.ecgExams.push(exam)
            else if (this.usGenral.includes(exam.ExamType)) {
              this.usGeneralExams.push(exam)
            }
            else
              this.notFormExams.push(exam)
          }
        })
      }
      if(this.login.isUSG){
        this.examsLoaded$.next();
        this.ds.BuildList
      }
      if (this.pat.AWLID) {
        if (!this.login.isUSG) {
          for (let i = 0; i < this.pregnancies.length; i++) {
            for (let e of this.pregnancies[i]['exams']) {
              if (e.AWLID == this.pat.AWLID) {
                this.AWLAlreadyExists = true;
                return;
              }
            }
          }
        }
        for (let e of this.otherExams) {
          if (e.AWLID == this.pat.AWLID) {
            this.AWLAlreadyExists = true;
            return;
          }
        }
      }else{
        if(this.login.isCardio){
          this.patService.getPatAWL()
          
        }
      }
    },
      (error) => {//add this later
        console.error(error);
      });
    this.subscription = this.examsLoaded$.subscribe(() => {
      // Exams loaded, no need for visits logic
    })
    this.login.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      /*if(this.login.ClinicID && this.login.ClinicID != this.startClinic){
        //trying to switch clinics on opening exams
        this.showLogin=false;
        this.cErr.Error = "Clinic Not Autorized on this patient";
        this.cErr.ErrorType = "Clinic Switched on Login";
        return;
      }*/
      if (this.goEx) {
        this.examService.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
      }
      else{
        if (this.etype == 'GastroForms' || this.examname =='Inform Consent' || this.concentForm) {
          this.showLogin = false;


          if(this.etype == 'GastroForms'){
            this.typeForm = true;
            this.inform=false;
            var awl = this.pat.AWLID ? this.pat.AWLID.toString() : null;
            this.examsLoaded$.next();
          }
          if(this.examname =='Inform Consent' || this.concentForm)
            this.inform=true;
        } else {
          // Obstetric consent form disabled — no obstetric exams are started from this flow, so it should never open.
          // const isObstetricExam = !this.usGenral.includes(this.examname) && !this.CARDIO.includes(this.examname) && !this.ECG.includes(this.examname);
          // if(isObstetricExam && this.pregnancies.length > 0 && this.pregnancies[0].forms.filter((i) => i.ExamType == this.examname && !i.ExamID).length == 0 && !this.login.ishospital  && this.login.premissions.Consent ){
          //   this.inform = true;
          //   this.showLogin = false;
          //   this.examService.openNewExam = true;
          // }else{
            // No pregnancy records in this deployment — concentForm from pregnancy is irrelevant.
            // if(this.pregnancies.length > 0)
            //   this.examService.concentForm = this.pregnancies[0].forms.filter((i) => i.ExamType == this.examname && !i.ExamID)[0]
            this.examService.subExamType = this.endoscopySubType || '';
            this.examService.startExam(this.examname, this.pat.PID, this.pat.ID, this.pat.AWLID, this.pat.ExamLMP);
          // }
        }
      }
    });
  }

  viewonly() {
    this.examService.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }
  startForm(form = null) {
    if (this.examService.consentType || form) {
      this.examService.examID = null;
      this.concentForm = form;
      if (form?.ConsentType) {
        this.examService.consentType = form.ConsentType;
      }
      this.examService.openNewExam = false;
      this.showUsgConsent = true;
    } else {
      this.concentForm = null;
      this.showUsgConsent = false;
      this.showLogin = true;
      return;
    }
  }

  checkUsgConsentBeforeExam() {
    const today = new Date().toDateString();
    const sameDay = this.usgConsents.filter(c => new Date(c.CreationTime).toDateString() === today);
    // HRA exams have their own consent form; every other endoscopy sub-type uses the general one
    const consentKey = this.endoscopySubType === 'HRA' ? 'HRA' : 'Endoscopy';
    const hasConsent = sameDay.some(c => resolveConsentTypeKey(c.ConsentType) === consentKey);
    if (!hasConsent) {
      this.examService.consentType = consentKey;
      this.examService.openNewExam = true;
      this.showUsgConsent = true;
    } else {
      this.concentForm = null;
      this.newExam = true;
      this.showLogin = true;
    }
  }

  closeUsgConsent(event) {
    this.showUsgConsent = false;
    if (this.login.premissions?.Consent) {
      this.examService.getUsgConsents(this.pat.PID.toString()).subscribe(
        (data) => { this.usgConsents = data || []; },
        () => {}
      );
    }
    this.closCalForm(event);
  }
  goForm(form) {

    this.typeForm = true;
    var isTimeOut = form['FormName'] =='Time Out Form';
    this.gfs.awlIndex=form['AWLID']
    this.gfs.loadForm(isTimeOut,form,undefined,undefined,form['FormName'])
  }

  startExam(ignoreCheckFormExist=false) {
    console.log('startExam called with examname:', this.pat);
    this.examService.examID = null;

    if (this.examname === 'Send Questionnaire') { this.openSendQuestionnaireForPatient(); return; }

    if (!this.etype || !this.examname)
      return;
    
    // Check TodayList permission - requires AWLID and matching exam type
    // Exclude consultation types from TodayList requirement
    const consultationTypes = ['Consultation Letter', 'Clinics', 'consultation and follow up with media'];
    if (this.login.premissions?.TodayList && !consultationTypes.includes(this.examname)) {
      if (!this.pat.AWLID) {
             return this.ce.errorGastro("Today List Missing", 'Must select exam type in Today List')

      }
      // Endoscopy sub-types are booked under their own Today List code (e.g. 'HRA'); the exam itself is always 'Endoscopy'
      const todaySubType = ENDOSCOPY_CODE_TO_SUBTYPE[this.pat['ExamCode']];
      if (todaySubType) {
        if (this.examname !== 'Endoscopy' || (this.endoscopySubType && this.endoscopySubType !== todaySubType)) {
          return this.ce.errorGastro("Today List", `Today List only allows ${this.pat['ExamCode']} `)
        }
        this.endoscopySubType = todaySubType;
      }
      else if (this.examname !== this.pat['ExamCode']) {
       return this.ce.errorGastro("Today List", `Today List only allows ${this.pat['ExamCode']} `)
      }
    }
    
    if (this.pat.ID != "default") {
      if (this.examname === 'Endoscopy' && this.login.premissions?.Consent) {
        this.checkUsgConsentBeforeExam();
        return;
      }
      this.concentForm = null;
      this.newExam = true;
      this.showLogin = true;
      return;
    }
    else {//default
      this.examService.subExamType = this.endoscopySubType || '';
      if (this.defaults[this.examname]) {
        this.examService.goExam(null, this.defaults[this.examname], this.examname);
      }
      else
        this.examService.startExam(this.examname, 0, "default");
    }
  }

  selectClinicTemplate(t: any) {
    this.selectedClinicTemplateId = t.ClinicTemplateID;
    this.examname = 'Clinics';
    this.examService.pendingClinicTemplate = { Title: t.Title, TemplateContent: t.TemplateContent, ClinicTemplateID: t.ClinicTemplateID, TemplateKind: t.TemplateKind };
  }

  clearClinicSelection() {
    this.selectedClinicTemplateId = null;
    this.examService.pendingClinicTemplate = null;
  }

  onEtypeChange() {
    this.clearClinicSelection();
    this.examname = '';
  }

  onEndoscopySubTypeChange() {
    this.examname = 'Endoscopy';
  }

  onEtypeEndoscopyChange() {
    this.clearClinicSelection();
    this.endoscopySubType = '';
    this.examname = '';
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.examUnSignedSub) {
      this.examUnSignedSub.unsubscribe();
    }
    this.gfs.awlIndex=null
  }

  canOpen(): boolean {
    return this.login.canStartExam(this.pat.AWLID != null) && (!this.AWLAlreadyExists || this.login.AWLUnlimited) && (! this.login.separatedClinic || this.login.isAdmin || ! this.patService.getPat().UID || this.patService.getPat().UID == this.login.UID || this.patService.getPat()['AWLUID'] == this.login.UID);
  }

  getSubExamLabel(subType: string): string {
    const labels = { Other: 'Other', HRA: 'HRA',Gastro: 'Gastroscopy', Colonoscopy: 'Colonoscopy', Both: 'Gastro + Colonoscopy' };
    return labels[subType] || subType;
  }

  goExam(pregid: number, exam, examtype: string, examtime: string) {

    this.examService.examObject = exam; // Reassign the exam object again.

    // For login for Edit, reassign new un-singed exam to the goEx:
    this.examUnSignedSub = this.signatureService.examUnSigned$.subscribe((data: Exam) => {
      this.goEx = { preg: pregid, exam: data, etype: examtype };
    });

    const canOpenExam = (userType: string): boolean => {
      return (
        userType === "doctor" ||
        userType === "visitingdoc" ||
        userType === "tech" ||
        userType === "nurse"
      );
    };

    if ((exam.Locked && exam.LockedBy.toLowerCase() != this.login.loginname.toLowerCase()) || ! this.canView(exam)){
      return;
    }
    
    let etime = new Date(examtime);
    var closed;
    if(exam.ClosedDate)
      closed = new Date(exam.ClosedDate);
    let now = new Date();
  
    if (examtype !== "Emergency Room" && ((!this.signatureService.isExamSigned(exam))) && canOpenExam(this.login.userType)) {
      this.newExam = false;
      this.showLogin = true;
      this.goEx = { preg: pregid, exam: exam, etype: examtype };
      if (this.login.ClinicID) {
        this.startClinic = this.login.ClinicID;
      }
    } else {
      if (canOpenExam(this.login.userType)) {
        this.newExam = false;
        this.showLogin = true;
        this.examService.examID = exam.AutoIndex;
        this.goEx = { preg: pregid, exam: exam, etype: examtype };
      } else {
        this.examService.goExam(pregid, exam, examtype,true);
      }
    }
  }

  canView(exam){
    return ! this.login.separatedClinic || this.login.isAdmin || this.login.userType == 'secretary' ||  this.login.userType === 'nurse' || exam.UID == this.login.doctor;
  }

  askDelete(exam, document = false) {
    if (document) {
      this.documentDelete = true;
      this.toDelete = exam;
    } else if (this.defaults || this.signatureService.canDeleteExam(exam)) {
      this.toDelete = exam;
    }
    return false;
  }

  openDocument(docId) {
    window.open(`api/patient/getDocument/${docId}`);
  }

  deleteDocument() {
    if (!this.toDelete || !this.toDelete.AutoIndex) return;
    const docId = this.toDelete.AutoIndex;
    this.http.delete(`api/patient/document/${docId}`).subscribe(() => {
      this.AttachedDocuments = this.AttachedDocuments.filter(d => d.AutoIndex != docId);
      this.toDelete = null;
      this.documentDelete = false;
    });
  }

  refreshDocuments() {
    this.http.get(`api/patient/getDocuments/${this.pat.PID}`).subscribe((data: any) => {
      this.AttachedDocuments = data.documents || [];
    });
  }

  deleteExam() {
    this.pat.AWLID = this.toDelete.AWLID;
    this.examService.deleteExam(this.toDelete.AutoIndex, this.toDelete.AWLID);
    if (!this.defaults) {
      for (let i = 0; i < this.pregnancies.length; i++) {
        for (let j = 0; j < this.pregnancies[i]['exams'].length; j++) {
          if (this.pregnancies[i]['exams'][j].AutoIndex == this.toDelete.AutoIndex) {
            this.pregnancies[i]['exams'].splice(j, 1);
            break;
          }
        }
      }
      for (let i = 0; i < this.otherExams.length; i++) {
        if (this.otherExams[i].AutoIndex == this.toDelete.AutoIndex) {
          this.otherExams.splice(i, 1);
          break;
        }
      }
    }
    else {
      this.examService.getDefaults().subscribe((data) => {
        this.defaults = [];
        for (let i = 0; i < data["length"]; i++)
          this.defaults[data[i]["ExamType"]] = data[i];
      }, (error) => {
        console.error(error);
      })
    }
    this.toDelete = null;
    this.readydelete = false;
  }

  showClose(pregid: number) {

  }
  closCalForm(event){
    if(event == '2' || this.examService.openNewExam){
      this.examService.subExamType = this.endoscopySubType || '';
      this.examService.startExam(this.examname, this.pat.PID, this.pat.ID, this.pat.AWLID, this.pat.ExamLMP, this.examService.concentForm);
    }
    this.examService.openNewExam = false;
    this.calendarForm = false;
    this.inform=false;
    if (this.pat.ID != "default") {
      this.resetPregs();
    }
    else {//defaults
      this.examService.getDefaults().subscribe((data) => {
        this.defaults = [];
        for (let i = 0; i < data["length"]; i++)
          this.defaults[data[i]["ExamType"]] = data[i];
      },
        (error) => {
          console.error(error);
        });
    }
  }

  deleteDefault(ex: string) {
    if (this.defaults[ex]) {
      this.askDelete(this.defaults[ex])
    }
  }

  getDiagnosis(exam, show = false){
    var strDiagnosis ='No relevant data';
    if(exam && exam.DiagnosisCodes){
      var temp =this.ds.BuildList(exam.DiagnosisCodes);
      if(temp.length > 0){
        strDiagnosis = '';
        for(let i=0;i<temp.length;i++){
          strDiagnosis +=temp[i][1].split('>')[temp[i][1].split('>').length -1 ]
          if(temp.length >1 && i < temp.length -1)
            strDiagnosis += ","
        }
      }
    }else if(exam && exam.Anomalies && exam.Anomalies !='')
      strDiagnosis = exam.Anomalies
    if(show && exam['Anomalies'] && exam.Anomalies.length >15)
      // return 'Read More'
      return exam.Anomalies.split(" ")[0] + "...";
    else
      return strDiagnosis;
    
  }
  loadCalendarForm(form){
    this.calendarForm = true;
    this.selectedForm = form;
  }

  getConcent(exam){
    var temp = this.examService.pregnancies.filter((i) => i.AutoIndex == exam.PregIndex)
    if(temp.length > 0){
      temp = temp[0].forms.filter((i) => i.ExamID == exam.AutoIndex)
    } 
    if(temp.length>0)
      return temp[0];
    else
      return false;

  }

  pregClosed(){
    for(let p of this.pregnancies){
      if(p.AutoIndex == this.closePreg)
        p.ClosedDate = new Date();
    }
    this.closePreg=null;
  }
  togglePrintPopup(examId=null) {
    this.examIdSelectedPrintForm=examId
    this.showPrintPopup = !this.showPrintPopup;
  }

   printPathologyForm(examId) {
    let printUrl: string;
    let autoIndex;

    if (examId) {
      autoIndex =  examId
      printUrl = `api/gastro/pathologyFormPrint/${autoIndex}`;
      window.open(printUrl);
    }
    return

  }

  openReferralPrintout(referralId) {
    if (referralId) {
      window.open(`/api/referrals/printpdf/${referralId}/he`, '_blank');
    }
  }

  askDeleteReferral(exam: any, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.referralToDelete = exam;
    this.referralDeleteReady = false;
  }

  confirmDeleteReferral() {
    if (!this.referralToDelete || !this.referralToDelete.ReferralId) return;
    const exam = this.referralToDelete;
    this.referralService.deleteReferral(exam.ReferralId).subscribe(
      () => {
        exam.ReferralId = null;
        this.referralToDelete = null;
        this.referralDeleteReady = false;
      },
      () => {
        this.referralToDelete = null;
        this.referralDeleteReady = false;
      }
    );
  }

  existFormForTodayLastVisit(formName) {
    // Forms checking removed - no longer dependent on visits
    return false;
  }

  getBacColor(formName: string): string {
    return this.existFormForTodayLastVisit(formName) ? '#277382' : '#e5eef0';
  }

  getStyle(formName:string){
   const backGround={'background-color': this.getBacColor(formName)}
   const fontColor={'color':this.getFontColor(formName)}
   return {...backGround,...fontColor}

  }

  getFontColor(formName: string){
    return this.existFormForTodayLastVisit(formName) ? '#FFFFFF' : '#015a6c';
  }

  getLabInbox(){
    this.pathologyService.getLabReports(false).subscribe((data: any[]) => {
      this.patInbox = data;
    });
  }

  openPrescription(prescriptionId?: number, createdAt?: string) {
    const pat = this.patService.getPat();
    const ref = this.dialog.open(PrescriptionDialogComponent, {
      data: {
        PID: pat.PID ? pat.PID.toString() : pat.ID,
        GID: this.login.GID,
        patientName: (pat.First || '') + ' ' + (pat.Last || ''),
        patientID: pat.ID,
        patientDOB: pat.Birth,
        HMO: pat.HMO || '',
        existingPrescriptionId: prescriptionId || null,
        existingCreatedAt: createdAt || null
      },
      width: '980px',
      height: '700px'
    });
    ref.afterClosed().subscribe(() => {
      this.prescriptionService.getAll(this.pat.PID.toString(), this.login.GID).subscribe(
        (data) => { this.prescriptions = data; },
        () => {}
      );
    });
  }

  askDeletePrescription(rx: Prescription, event: MouseEvent) {
    event.preventDefault();
    this.prescriptionToDelete = rx;
    this.prescriptionDeleteReady = false;
  }

  confirmDeletePrescription() {
    if (!this.prescriptionToDelete) return;
    this.prescriptionService.deletePrescription(this.prescriptionToDelete.AutoIndex).subscribe(
      () => {
        this.prescriptions = this.prescriptions.filter(p => p.AutoIndex !== this.prescriptionToDelete.AutoIndex);
        this.prescriptionToDelete = null;
        this.prescriptionDeleteReady = false;
      },
      () => {}
    );
  }

  
  private resolveConsentPractitioner(): any {
    const pat = this.patService.getPat() as any;
    if (this.clinicPractitioners.length < 2 || this.login.separatedClinic) {
      if (this.login.separatedClinic) {
        return this.clinicPractitioners.find((p) => p.UID == pat?.UID) || null;
      }
      return this.clinicPractitioners[0] || null;
    }
    // Multi-doctor non-separated clinic — use appointment doc if available
    if (pat?.appointmentId) {
      return this.clinicPractitioners.find((p) => p.UID == pat.AppointmentDocUID) || null;
    }
    return null;
  }

  setConsentDocUID() {
    let selectedDoc: any;
    if (this.login.userType === 'doctor') {
      selectedDoc = this.login;
    } else {
      selectedDoc = this.clinicPractitioners.find((user) => {
        return user?.Title + ' ' + user?.Name === this.examService.consentPractitioner;
      });
    }
    this.examService.consentDocUID = selectedDoc?.UID;
  }

  checkApprovedConcent(consent: any) {
    let valid = false;
    if (
      consent.approved &&
      consent.approved !== 'appotropus' &&
      consent.patSign &&
      consent.patSignApproved &&
      consent.docSign
    ) {
      valid = true;
    } else if (
      consent.approved &&
      consent.approved === 'appotropus' &&
      consent.patSign &&
      consent.docSign
    ) {
      valid = true;
    }
    return valid;
  }

  checkApprovedUsgConsent(consent: any): boolean {
    return !!(consent?.docSign && consent?.patSign);
  }

  loadCurrentSignature() {
    this.signatureLoading = true;
    try {
      this.signatureService.checkSignatureExists().subscribe(
        (blob: Blob) => {
          this.signatureLoading = false;
          if (blob && blob.size > 0) {
            this.currentSignatureUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
          } else {
            this.currentSignatureUrl = null;
          }
        },
        (error) => {
          this.signatureLoading = false;
          this.currentSignatureUrl = null;
          console.error('Error loading signature:', error);
        }
      );
    } catch (error) {
      this.signatureLoading = false;
      this.currentSignatureUrl = null;
      console.error('Error loading signature:', error);
    }
  }

  deleteSignature() {
    this.signatureLoading = true;
    try {
      this.signatureService.deleteSignature().subscribe(
        () => {
          this.currentSignatureUrl = null;
          this.signatureLoading = false;
          this.signatureUploadStatus = '';
        },
        (error) => {
          this.signatureLoading = false;
          console.error('Error deleting signature:', error);
        }
      );
    } catch (error) {
      this.signatureLoading = false;
      console.error('Error deleting signature:', error);
    }
  }

  onSignatureFileSelected(event: Event) {
    try {
      const input = event.target as HTMLInputElement;
      const file = input?.files?.[0];
      if (!file) return;
      this.signatureUploadStatus = '';
      this.signatureLoading = true;
      this.signatureService.uploadSignature(file).subscribe(
        () => {
          this.signatureUploadStatus = 'Signature uploaded successfully';
          this.loadCurrentSignature();
        },
        (error) => {
          this.signatureLoading = false;
          this.signatureUploadStatus = 'Upload failed';
          console.error('Error uploading signature:', error);
        }
      );
      input.value = '';
    } catch (error) {
      this.signatureLoading = false;
      this.signatureUploadStatus = 'Upload failed';
      console.error('Error uploading signature:', error);
    }
  }

  loadPractitionerSignature(uid: string) {
    if (!this.practitionerSignatures[uid]) {
      this.practitionerSignatures[uid] = { url: null, loading: true, status: '' };
    } else {
      this.practitionerSignatures[uid].loading = true;
    }
    try {
      this.signatureService.checkSignatureExists(uid).subscribe(
        (blob: Blob) => {
          this.practitionerSignatures[uid].loading = false;
          if (blob && blob.size > 0) {
            this.practitionerSignatures[uid].url = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
          } else {
            this.practitionerSignatures[uid].url = null;
          }
        },
        (error) => {
          this.practitionerSignatures[uid].loading = false;
          this.practitionerSignatures[uid].url = null;
          console.error(`Error loading signature for ${uid}:`, error);
        }
      );
    } catch (error) {
      this.practitionerSignatures[uid].loading = false;
      this.practitionerSignatures[uid].url = null;
      console.error(`Error loading signature for ${uid}:`, error);
    }
  }

  loadAllPractitionerSignatures() {
    try {
      for (const p of this.clinicPractitioners) {
        this.loadPractitionerSignature(p.UID);
      }
    } catch (error) {
      console.error('Error loading practitioner signatures:', error);
    }
  }

  onPractitionerSignatureSelected(uid: string, event: Event) {
    try {
      const input = event.target as HTMLInputElement;
      const file = input?.files?.[0];
      if (!file) return;
      if (!this.practitionerSignatures[uid]) {
        this.practitionerSignatures[uid] = { url: null, loading: true, status: '' };
      }
      this.practitionerSignatures[uid].status = '';
      this.practitionerSignatures[uid].loading = true;
      this.signatureService.uploadSignatureForUid(uid, file).subscribe(
        () => {
          this.practitionerSignatures[uid].status = 'Uploaded successfully';
          this.loadPractitionerSignature(uid);
        },
        (error) => {
          this.practitionerSignatures[uid].loading = false;
          this.practitionerSignatures[uid].status = 'Upload failed';
          console.error(`Error uploading signature for ${uid}:`, error);
        }
      );
      input.value = '';
    } catch (error) {
      if (this.practitionerSignatures[uid]) {
        this.practitionerSignatures[uid].loading = false;
        this.practitionerSignatures[uid].status = 'Upload failed';
      }
      console.error(`Error uploading signature for ${uid}:`, error);
    }
  }

  deletePractitionerSignature(uid: string) {
    if (!this.practitionerSignatures[uid]) {
      this.practitionerSignatures[uid] = { url: null, loading: true, status: '' };
    }
    this.practitionerSignatures[uid].loading = true;
    try {
      this.signatureService.deleteSignatureForUid(uid).subscribe(
        () => {
          this.practitionerSignatures[uid].url = null;
          this.practitionerSignatures[uid].loading = false;
          this.practitionerSignatures[uid].status = '';
        },
        (error) => {
          this.practitionerSignatures[uid].loading = false;
          console.error(`Error deleting signature for ${uid}:`, error);
        }
      );
    } catch (error) {
      this.practitionerSignatures[uid].loading = false;
      console.error(`Error deleting signature for ${uid}:`, error);
    }
  }

  // AR-24 first-pass send wiring (patient history).
  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }

  // AR-24: triggered from Create-New > Letters and Certificates > Send
  // Questionnaire. No ExamType is passed, so the popup preselects nothing
  // and the user picks which questionnaire to send.
  onSendQuestionnaireClosed() {
    this.showSendQuestionnaire = false;
    if (this.pat && this.pat.PID != null) this.resetPregs();
  }

  openSendQuestionnaireForPatient() {
    const p: any = this.pat || {};
    this.openSendQuestionnaire({ Mobile: p.Mobile || p.Phone || '', ID: p.ID, PID: p.PID });
  }

  // AR-24 change 2: load this patient's questionnaire sends for the history list.
  loadPatientQuestionnaires() {
    if (!(this.login.premissions?.Questionnaires) || !this.pat || this.pat.PID == null) return;
    this.examService.getPatientQuestionnaires(this.pat.PID).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        this.patientQuestionnaires = (data && data.items) || [];
      },
      (error) => { console.log(error); }
    );
  }

  openQuestionnairePdf(q: any) {
    if (q && q.answeredDate && q.code) {
      window.open('api/questionnaires/pdf/' + q.code);
    }
  }

}
